function username_truncate(limit,username){
    if(username.length > limit){
     return username.substring(0,limit).concat("...")
    }else{
        return username
    }
  }

  export {username_truncate}